<script>
export default {
  name: "Footer-Screen",

  computed: {
    isAdminUp(){
        const privilege = this.getCookie("up");
            return privilege === "admin"
    }

  },
  methods: {
      getCookie(name) {
      const cookies = document.cookie.split("; ");
      for (let cookie of cookies) {
          const [cookieName, cookieValue] = cookie.split("=");
          if (cookieName === name) {
          return decodeURIComponent(cookieValue);
          }
      }
      return null;
      },
  },
};
</script>

<template>
    <footer class="bg-light text-dark">

        <!-- Admin Footer Content -->
        <div class="bg-light text-secandary py-1" >
            <div class="container">
                <div class="row text-center text-md-left align-items-center">
                <div class="col-md-4 mb-2 mb-md-0">
                    <p class="mb-0 " style="font-size: 12px;" >
                    © 2026 TufraTech Copyright
                    </p>
                </div>
                <div class="col-md-4 mb-2 mb-md-0 text-center" style="font-size: 12px;" >
                    <p class="mb-0 text-uppercase">transformation numérique</p>
                </div>
                <div class="col-md-4 text-md-right">
                    <p class="mb-0" style="font-size: 12px;">
                    Powered by 
                    <a href="https://tufratech.com/" class="text-primary fw-bold" target="_blank" rel="noopener noreferrer">
                        TufraTech
                    </a> 
                    v1.1.4.Beta
                    </p>
                </div>
                </div>
            </div>
        </div>

    </footer>
  </template>
  

